import React from 'react';

export default function Header() {

  return (
    <header className="header">
      <div className="headerInner">
        <h1><span className="blue">Artemio</span> <span className="purple">Morales</span></h1>
        <ul>
          <li><a href="#overview">Overview</a></li>•
          <li><a href="#startupWork">Startup Work</a></li>•
          <li><a href="#gameJams">Game Jams</a></li>•
          <li><a href="#employment">Contract Work</a></li>•
          <li><a href="#contact">Contact</a></li>
        </ul>
      </div>
    </header>
  )

}